{
    "UserTour_Next": "Seguinte",
    "UserTour_Cancel": "Mostrar-me mais tarde",
    "UserTour_Exit": "Desativar visito separadorda",
    "NAME": "UserTour"
}